const getChartOptions = () => {
  var themeColor = getComputedStyle(document.body)
    .getPropertyValue('--bs-theme')
    .trim();
  var themeColorRgb = getComputedStyle(document.body)
    .getPropertyValue('--bs-theme-rgb')
    .trim();

  return {
    bar: {
      colors: [themeColor],
      chart: { sparkline: { enabled: true } },
      tooltip: {
        enabled: false,
        x: { show: false },
        y: { title: { formatter: function () { return ''; } } },
      },
      dataLabels: { enabled: false },
      events: { mouseMove: function () { return false; } },
    },
    line: {
      colors: [themeColor],
      chart: { sparkline: { enabled: true } },
      stroke: { curve: 'straight', width: 2 },
      tooltip: {
        enabled: false,
        x: { show: false },
        y: { title: { formatter: function () { return ''; } } },
      },
      dataLabels: { enabled: false },
      events: { mouseMove: function () { return false; } },
    },
    pie: {
      colors: [
        'rgba(' + themeColorRgb + ', 1)',
        'rgba(' + themeColorRgb + ', .75)',
        'rgba(' + themeColorRgb + ', .5)',
      ],
      chart: { sparkline: { enabled: true } },
      stroke: { show: false },
      tooltip: {
        enabled: false,
        x: { show: false },
        y: { title: { formatter: function () { return ''; } } },
      },
      dataLabels: { enabled: false },
      events: { mouseMove: function () { return false; } },
    },
    donut: {
      colors: [
        'rgba(' + themeColorRgb + ', .15)',
        'rgba(' + themeColorRgb + ', .35)',
        'rgba(' + themeColorRgb + ', .55)',
        'rgba(' + themeColorRgb + ', .75)',
        'rgba(' + themeColorRgb + ', .95)',
      ],
      chart: { sparkline: { enabled: true } },
      stroke: { show: false },
      tooltip: {
        enabled: false,
        x: { show: false },
        y: { title: { formatter: function () { return ''; } } },
      },
      dataLabels: { enabled: false },
      events: { mouseMove: function () { return false; } },
    },
  };
};

export default getChartOptions;
